import { render, staticRenderFns } from "./RegistroCandidatosCapacitacion.vue?vue&type=template&id=4f2e7226&scoped=true"
import script from "./RegistroCandidatosCapacitacion.vue?vue&type=script&lang=js"
export * from "./RegistroCandidatosCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./RegistroCandidatosCapacitacion.vue?vue&type=style&index=0&id=4f2e7226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e7226",
  null
  
)

export default component.exports